<template>
  <div>
    <el-dialog :title="$t('system.update_role')" :close-on-click-modal="false" :visible.sync="dialogUserVisible" class="diglog-card" width="800px" @close="initData">
      <div class="header-line" />
      <div style="margin-top: 20px">
        <div class="add-role-dec">
          <p>{{ $t('system.role_details') }}</p>
        </div>
        <div class="add-role-form">
          <el-form ref="form" :model="form" label-width="200px" :rules="rules" label-position="top">
            <el-form-item :label="$t('system.role_name')" prop="role_name" required>
              <el-input v-model="form.role_name" size="small" placeholder="Enter Role Name" class="search-frame" autocomplete="off" clearable disabled />
            </el-form-item>
            <el-form-item :label="$t('system.remark')" prop="remark">
              <el-input v-model="form.remark" size="small" placeholder="Enter your message here" class="search-frame" autocomplete="off" clearable disabled />
            </el-form-item>

            <div class="add-role-dec">
              <p>{{ $t('system.permissions') }}</p>
              <span>{{ $t('tips.following_permission_granted_role') }}</span>
            </div>
            <div class="role-item-line" />

            <el-form-item prop="role_auths" style="margin-top: 10px">
              <SystemMchMenu
                :menu-list="menuList"
                :auth-list="form.role_auths"
                :locked-code-list="locked_code_list"
                :modal-flag="modalFlag"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogUserVisible = false">{{ $t('components.cancel') }}</el-button>
        <el-button type="primary" :disabled="listLoading" @click="submitUpdateRole('form')">{{ $t('components.submit') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { updateMchRole } from '@/api/system/system'
export default {
  name: 'updateRoleModal',
  components: {
    SystemMchMenu: () => import('../System/SystemBaseMenu'),
  },
  props: {
    menuList: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      dialogUserVisible: false,
      listLoading: false,
      form: {
        role_id: '',
        role_name: '',
        remark: '',
        role_auths: []
      },
      locked_code_list: [],
      // cities: cityOptions,
      modalFlag: 2,
      rules: {},
      isIndeterminate: true,
      checkAll: false
    }
  },
  mounted() {
    this.$bus.off('UPDATE_CHECK_AUTH_MODIFY_MODAL')
    this.$bus.on('UPDATE_CHECK_AUTH_MODIFY_MODAL', (value) => {
      this.form.role_auths = JSON.parse(JSON.stringify(value))
    })
  },
  methods: {
    changeModalStatus(status, row) {
      this.dialogUserVisible = status
      this.form = {
          role_id: row.id,
          role_name: row.role_name,
          remark: row.remark,
          role_auths: row.auth_codes,
      }
      this.modalFlag = 2
      if(row && row.role_name === 'Admin(Default)') {
        this.modalFlag = 4
      }
      if(this.modalFlag === 2 || this.modalFlag === 4) {
        this.locked_code_list = row.auth_codes
      }
      this.$nextTick(function() {
        this.$refs['form'].clearValidate()
      })
    },
    initData() {
      this.form = {
        role_id: '',
        role_name: '',
        remark: '',
        role_auths: []
      }

    },
    submitUpdateRole(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('tips.whether_to_submit'), this.$t('components.tips'), {
            confirmButtonText: this.$t('components.submit'),
            cancelButtonText: this.$t('components.cancel'),
            type: 'warning'
          }).then(() => {
            this.listLoading = true
            const params = {
              role_id: this.form.role_id,
              auth_codes: this.form.role_auths
            }
            updateMchRole(params).then(res => {
              this.$message.success('Success')
              this.$emit('updateRoleList')
              this.dialogUserVisible = false
            }).finally(() => {
              this.listLoading = false
            })
          })
        }
      })
    },
    handleCheckAllChange() {

    },
    handleCheckedChange() {

    }
  }
}
</script>

<style scoped>
.add-role-dec > p {
  font-style: normal;
  font-weight: 600;  font-family: 'Inter-SemiBold';
  font-size: 18px;
  line-height: 22px;
  color: #000000;
}

.add-role-dec > span {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #7A869E;

}
.role-item-line {
  margin-top: 24px;
  border-bottom: 1px solid #D3D7DF;
}
.add-role-form {
  margin-top: 24px;
}
.checkboxItem{
  display: block;
  padding-left: 40px;
}
</style>
